export class ResetPasswordDto  {
public newPassword :string ;
public reTypePassword :string ;
public expiryDate :Boolean;
public resultPage :string ;
public userId :number;
public message :string ;


}